import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _ConfigProvider from "sunway-ui-vue/src/config-provider";
import _Chat from "sunway-ui-vue/src/chat";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import Gikam from 'gikam';
import Vue from 'vue';
// import SockJS from 'sockjs-client';
// import Stomp from 'stompjs';
import Base from '../base.js';
export var ChatBase = /*#__PURE__*/function (_Base) {
  _inherits(ChatBase, _Base);

  var _super = _createSuper(ChatBase);

  function ChatBase() {
    _classCallCheck(this, ChatBase);

    return _super.apply(this, arguments);
  }

  _createClass(ChatBase, [{
    key: "init",
    value: function init(props, defaultOptions) {
      this.initialize(props, defaultOptions);
      this.model = this.createModel();
      this.initFriendList();
      this.initWebSocket();
    }
  }, {
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;
      this.initModelData();
      var userInfo = this.getUserInfo();
      var onBeforeChatOpen = this.onBeforeChatOpen;
      return new Vue({
        el: Gikam.createDom('div', this.options.renderTo || document.body),
        data: this.viewData,
        render: function render() {
          var h = arguments[0];
          return h(_ConfigProvider, [h(_Chat, {
            "ref": "chat",
            "attrs": {
              "userInfo": userInfo,
              "friendList": this.friendList,
              "sendFile": this.sendFile,
              "sendMessage": this.sendMessage,
              "realtimeMessage": this.realtimeMessage,
              "getRecentContact": this.getRecentContact,
              "getRecentMessages": this.getRecentMessages
            },
            "on": {
              "beforeChatOpen": onBeforeChatOpen
            }
          })]);
        }
      });
    }
  }, {
    key: "initModelData",
    value: function initModelData() {
      this.viewData = {
        friendList: [],
        realtimeMessage: [],
        sendMessage: this.sendMessage.bind(this),
        sendFile: this.sendFile.bind(this),
        getRecentContact: this.getRecentContactList.bind(this),
        getRecentMessages: this.getRecentMessages.bind(this)
      };
    }
    /**
     * @description 获取好友列表
     * @static
     * @returns
     * @memberof ChatUtils
     */

  }, {
    key: "getFriendList",
    value: function getFriendList() {
      return new Promise(function (resolve) {
        var url = Gikam.IFM_CONTEXT + '/secure/core/module/im/groups/contactses/queries';
        Gikam.getJson(url).done(function (list) {
          return resolve(list);
        });
      });
    }
    /**
     * @description 初始化好友列表
     * @static
     * @param {*} chat
     * @memberof ChatUtils
     */

  }, {
    key: "initFriendList",
    value: function () {
      var _initFriendList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var friendList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getFriendList();

              case 2:
                friendList = _context.sent;
                this.viewData.friendList = friendList;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initFriendList() {
        return _initFriendList.apply(this, arguments);
      }

      return initFriendList;
    }()
  }, {
    key: "initSock",
    value: function initSock() {// const socket = new SockJS('ws://' + location.host + '/websocket/001');
      // const stompClient = Stomp.over(socket);
      // stompClient.debug = () => {
      //     return false;
      // };
      // stompClient.open = () => {
      //     console.info(1);
      // };
      // stompClient.connect({}, function() {});
    }
  }, {
    key: "initWebSocket",
    value: function initWebSocket() {
      var _this = this;

      this.socket = new WebSocket("ws://".concat(location.host, "/websocket/").concat(Gikam.loginUser.id));

      this.socket.onmessage = function (msg) {
        var _JSON$parse = JSON.parse(msg.data),
            type = _JSON$parse.type,
            data = _JSON$parse.data;

        _this["".concat(type, "Service")].call(_this, data);
      };
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      return new Promise(function (resolve, reject) {
        var data = Gikam.getJsonWrapper(null, ['', [message]]);
        Gikam.post(Gikam.IFM_CONTEXT + '/secure/core/module/im/messages/action/insert', data).done(function (result) {
          resolve(result);
        }).fail(function () {
          reject();
        });
      });
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var user = Gikam.deepExtend(Gikam.loginUser);

      if (Gikam.isNotEmpty(user.ext$.avatarurl)) {
        user.signature = Gikam.IFM_CONTEXT + user.ext$.avatarurl;
      }

      return user;
    }
  }, {
    key: "messageService",
    value: function messageService(data) {
      this.viewData.realtimeMessage = [JSON.parse(data)];
    }
  }, {
    key: "contactStateService",
    value: function contactStateService(data) {
      var _JSON$parse2 = JSON.parse(data),
          userId = _JSON$parse2.userId,
          imStatus = _JSON$parse2.imStatus;

      this.model.$refs.chat.updateContactState(userId, imStatus);
    }
  }, {
    key: "getRecentContactList",
    value: function getRecentContactList() {
      return new Promise(function (resolve) {
        var url = Gikam.IFM_CONTEXT + '/secure/core/module/im/messages/recent-contactses/queries';
        Gikam.post(url).done(function (data) {
          return resolve(data.rows);
        });
      });
    }
  }, {
    key: "onBeforeChatOpen",
    value: function onBeforeChatOpen(user) {
      Gikam.put(Gikam.IFM_CONTEXT + "/secure/core/module/im/messages/contactses/".concat(user.userId, "/action/read"));
    }
  }, {
    key: "getRecentMessages",
    value: function getRecentMessages(userId) {
      return new Promise(function (resolve) {
        var url = Gikam.IFM_CONTEXT + "/secure/core/module/im/messages/contactses/".concat(userId, "/queries");
        Gikam.post(url).done(function (data) {
          data.rows = data.rows.reverse();
          resolve(data);
        });
      });
    }
  }, {
    key: "sendFile",
    value: function sendFile(file) {
      return new Promise(function (resolve, reject) {
        var formData = new FormData();
        formData.append('name', file.name);
        formData.append('file', file);
        var xhr = new XMLHttpRequest();
        xhr.open('post', Gikam.IFM_CONTEXT + '/core/module/item/files', true);

        xhr.onreadystatechange = function () {
          if (this.readyState !== 4) {
            return;
          }

          if (this.status === 200) {
            resolve(this.response || this.responseText);
          } else {
            reject();
          }
        };

        xhr.send(formData);
      });
    }
  }]);

  return ChatBase;
}(Base);